import styled from 'styled-components'

export const StyledButton = styled.button`
	width: ${ ({ width }) => `${width ? width : '25'}px`};
	height: auto;
	background: none;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.3s;
	&:hover{
		transform: scale(1.2);
	}
`
